export const CreatedByRelationship = {
  CreatedBy: {
    fieldName: 'createdBy',
    Name: 'name',
    Id: 'id'
  },
  CreatedById: 'createdById'
}
